import errorDisc from '../../assets/svg/disc/error-disc.svg';
import withContentfulTag from '../../hocs/withContentfulTag';
import type { ContentfulTagProps } from '../../types/propTypes';

const SystemUnavailableContainer = ({ contentful }: Pick<ContentfulTagProps, 'contentful'>) => {
  return (
    <>
      <p>
        <img src={errorDisc} alt="Warning" />
      </p>
      <h1>{contentful?.title}</h1>
      <p>{contentful?.body}</p>
    </>
  );
};

export default withContentfulTag(SystemUnavailableContainer, 'web_app_service_unavailable_modal');
